<h1 class="text-decoration-underline">
  {{ title() }}
</h1>